import commonRes from '../abstract.resource';
import {readLocationArea} from '../serializers/location_area.serializer';

const mod = angular.module('app.common.resources.location_area', [commonRes])

.factory('LocationAreaResource', (AbstractResource) => {
  class LocationAreaResource extends AbstractResource {
    constructor() {
      super('locationareas', LocationAreaResource.fromBackend, true);
    }

    /**
     * Parse a location area retrieved from the backend.
     * @param {Object} o
     * @returns {LocationArea}
     */
    static fromBackend(o) {
      return readLocationArea(o).makeImmutable();
    }
  }

  return new LocationAreaResource();
});

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/resources/location-area.resource.js